// extracted by mini-css-extract-plugin
export default {"InlineFormContainer":"TermForm_InlineFormContainer__s6NBF","InlineFormItem":"TermForm_InlineFormItem__STeFz","DataContainer":"TermForm_DataContainer__XWtEj"};